<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<SearchTitle label='入科管理' label2="tips：1.生成入科报到通知单。2.学员签到 科室确认。3.分配带教。4.上传报到表。" url='/cycle/entry/list'>
			</SearchTitle>
			<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
				<!--begin: Search Form -->
				<div class="m-form m-form--label-align-right">
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">管理单元：</label>
							</div>
							<div class="m-form__control">
								<el-select v-model="condition.secretarysec" filterable placeholder="全部"
									@change="ManageSecChange">
									<el-option label="全部" value=""></el-option>
									<el-option v-for="item in managesecOptions" :key="item.DictItemID"
										:label="item.DictItemName" :value="item.DictItemID">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">轮转科室：</label>
							</div>
							<div class="m-form__control">
								<el-select v-model="condition.section" filterable placeholder="全部">
									<el-option label="全部" value=""></el-option>
									<el-option v-for="item in secOptions" :key="item.DictItemID"
										:label="item.DictItemName" :value="item.DictItemID">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
					<SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
					<SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
					<ZPGLSearchDictItemSelect v-model='condition.specialty' label='专业'
						:dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">状态：</label>
							</div>
							<div class="m-form__control">
								<el-select v-model="condition.cpstatus" filterable placeholder="全部">
									<el-option label="全部" value=""></el-option>
									<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">入科时间：</label>
							</div>
							<div class="m-form__control">
								<el-date-picker v-model="condition.entrydate" type="month" placeholder="入科时间"
									value-format="yyyy-MM">
								</el-date-picker>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">出科时间：</label>
							</div>
							<div class="m-form__control">
								<el-date-picker v-model="condition.outdate" type="month" placeholder="出科时间"
									value-format="yyyy-MM">
								</el-date-picker>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
				</div>
				<div style="clear: both;"></div>
				<div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
					<SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
					<el-button type="primary" icon="el-icon-search" @click="Notice" v-if="this.condition.rolelevel > 2">
						生成报到通知单</el-button>
					<el-button type="primary" icon="el-icon-search" @click="JumpTo">未入科名单</el-button>
					<el-button type="primary" icon="el-icon-download" @click="OutOutSectionList">出科考核名单</el-button>
					<el-button type="primary" icon="el-icon-download" @click="instuVisible = true">在培人员名单</el-button>
					<el-button type="primary" icon="el-icon-download" @click="Out">导出</el-button>
				</div>
				<!--end: Search Form -->
				<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
					<!--begin: Datatable -->
					<el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
						<el-table-column>
							<template slot="header">
								姓名<br>工号
							</template>
							<template slot-scope="scope">
								{{scope.row.CPStuName}}<br>{{scope.row.CPStuNo}}
							</template>
						</el-table-column>
						<el-table-column>
							<template slot="header">
								专业<br>用户类型
							</template>
							<template slot-scope="scope">
								{{scope.row.SpecName}}<br>{{scope.row.UserTypeName}}
							</template>
						</el-table-column>
						<el-table-column prop="ManageSecName" label="管理单元">
						</el-table-column>
						<el-table-column prop="SecName" label="轮转科室">
						</el-table-column>
						<el-table-column width="240">
							<template slot="header">
								轮转时间<br>请假时间
							</template>
							<template slot-scope="scope">
								{{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}<br />
								<div v-show='scope.row.LeaveBeginDate!=null' style="color: red;" v-for=" item in scope.row.LeaveBeginDate.split(',')" :key='item'>{{item}} </div>
							</template>
						</el-table-column>
						<el-table-column label="状态">
							<template slot-scope="scope">
								<div v-if="scope.row.CPStatus=='1'">
									{{scope.row.CPStatusName}}
								</div>
								<div v-if="scope.row.CPStatus=='2'">
									<span style="color: green;">{{scope.row.CPStatusName}}</span><br>
									{{scope.row.CPDate|formatFullDate}}
								</div>
								<div v-if="scope.row.CPStatus=='3'">
									<span style="color: red;">{{scope.row.CPStatusName}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="带教老师" width="150">
							<template slot-scope="scope">
								<div v-if="scope.row.CPStatus=='1'">
									<div style="float: left;width: 30px;height: 36px;line-height: 36px;">
										无
									</div>
									<div style="float: left;width: 60px;height: 36px;line-height: 36px;"
										v-if="UploadShow(scope.row)">
										<el-button @click="GetOAStatus(scope.row)" type="text" size="medium">[设置]
										</el-button>
									</div>
								</div>
								<div v-if="scope.row.CPStatus=='2' || scope.row.CPStatus=='3'">
									<div v-if="scope.row.CPTecID==null">
										<div style="float: left;width: 30px;height: 36px;line-height: 36px;">
											无
										</div>
										<div style="float: left;width: 60px;height: 36px;line-height: 36px;"
											v-if="UploadShow(scope.row)">
											<el-button @click="GetOAStatus(scope.row)" type="text" size="medium">[设置]
											</el-button>
										</div>
									</div>
									<div v-if="scope.row.CPTecID!=null">
										<div style="float: left;width: 50px;height: 36px;line-height: 36px;">
											{{scope.row.CPTecName}}
										</div>
										<div style="float: left;width: 60px;height: 36px;line-height: 36px;"
											v-if="condition.rolelevel=='3'">
											<el-button @click="GetOAStatus(scope.row)" type="text" size="medium">[设置]
											</el-button>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="报到通知单" width="150">
							<template slot-scope="scope">
								<div v-if="scope.row.CPStatus=='1' || scope.row.CPStatus=='3'">无</div>
								<div v-if="scope.row.CPStatus=='2'">
									<div v-if="scope.row.CPFile==null">
										<div style="float: left;width: 40px;height: 36px;line-height: 36px;">无</div>
										<div style="float: left;width: 75px;height: 36px;line-height: 36px;">
											<el-upload class="upload-demo" ref="upload" :action='uploadUrl'
												:data="{id:scope.row.CPID}" :limit="1"
												:before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess"
												:show-file-list="false">
												<a style="color:#66b1ff">[上传]</a>
											</el-upload>
										</div>
									</div>
									<div v-if="scope.row.CPFile!=null">
										<div style="float: left;width: 40px;height: 36px;line-height: 36px;">
											<el-button @click="See(scope.row)" type="text" size="medium">查看</el-button>
										</div>
										<div style="float: left;width: 75px;height: 36px;line-height: 36px;">
											<el-upload class="upload-demo" ref="upload" :action='uploadUrl'
												:data="{id:scope.row.CPID}" :before-upload="beforeAvatarUpload"
												:on-success="handleAvatarSuccess" :show-file-list="false">
												<a style="color:#66b1ff">[重新上传]</a>
											</el-upload>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<!--end: Datatable -->
					<div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]"
							:page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="condition.recordCount">
						</el-pagination>
					</div>
				</div>
				<el-dialog width="30%" title="设置带教老师" :visible.sync="dialogFormVisible">
					<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
						:model="form">
						<div class="m-portlet__body" style="height: 500px;overflow: auto;">
							<el-table v-loading="tecloading" :data="tectableData" stripe style="width: 100%"
								size="medium">
								<el-table-column prop="TrueName" label="姓名">
								</el-table-column>
								<el-table-column prop="CardNo" label="工号">
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button @click="SaveTec(scope.row)" type="text" size="medium">选择</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-form>
				</el-dialog>
				<el-dialog width="30%" title="通知设置" :visible.sync="noticeVisible">
					<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
						:model="noticeform">
						<div class="m-portlet__body">
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">教育科签名：</label>
								<div class="col-xl-6">
									<el-input v-model="noticeform.truename"></el-input>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">通知时间：</label>
								<div class="col-xl-6">
									<el-date-picker class="timeclass" v-model="noticeform.noticedate" type="date"
										placeholder="通知时间" value-format="yyyy-MM-dd">
									</el-date-picker>
								</div>
							</div>
						</div>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="DownLoad()" v-loading.fullscreen.lock="fullscreenLoading">下 载
						</el-button>
						<el-button type="primary" @click="Print()">预览</el-button>
					</div>
				</el-dialog>
				<el-dialog width="30%" title="在培人员名单下载" :visible.sync="instuVisible">
					<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
						:model="instuform">
						<div class="m-portlet__body">
							<div class="form-group m-form__group row">
								<label class="col-xl-4 col-form-label">轮转月份：</label>
								<div class="col-xl-6">
									<el-date-picker v-model="instuform.cpdate" type="month" placeholder="轮转月份"
										value-format="yyyy-MM">
									</el-date-picker>
								</div>
							</div>
						</div>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="InStuDownLoad" v-loading.fullscreen.lock="fullscreenLoading">导
							出</el-button>
					</div>
				</el-dialog>
				<el-dialog title="查看入科凭证" :visible.sync="noticeimgVisible" width="60%">
					<el-image :src="noticeimgurl" style="width: 100%;"></el-image>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import docxtemplater from 'docxtemplater'
	import JSZipUtils from 'jszip-utils'
	import saveAs from 'file-saver'
	import JSZip from 'jszip'
	export default {
		name: 'EntryList',
		data() {
			return {
				condition: {
					username: '',
					rolelevel: '',
					secid: '',
					truename: '',
					section: '',
					cardno: '',
					specialty: '',
					cpstatus: '',
					entrydate: '',
					outdate: '',
					listtype: 'entry',
					token: '',
					pageSize: 10,
					currentPage: 1,
					recordCount: 0,
					firstSearch: true,
					secretarysec: ''
				},
				tableData: null,
				tectableData: null,
				secOptions: [],
				managesecOptions: [],
				statusOptions: [{
					value: '1',
					label: '未入科'
				}, {
					value: '2',
					label: '已入科'
				}, {
					value: '3',
					label: '请假'
				}],
				dialogFormVisible: false,
				noticeVisible: false,
				noticeimgVisible: false,
				tecOption: null,
				form: {
					token: '',
					selectCPID: '',
					tecid: ''
				},
				noticeform: {
					token: '',
					username: '',
					rolelevel: '',
					truename: '',
					noticedate: '',
					realname: '',
					section: '',
					cardno: '',
					specialty: '',
					entrydate: '',
					outdate: '',
					secretarysec: ''
				},
				instuform: {
					cpdate: ''
				},
				instuVisible: false,
				searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/List',
				uploadUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/UploadEnterFile',
				loading: true,
				tecloading: false,
				zpdays: '',
				qkdays: '',
				fullscreenLoading: false,
				noticeimgurl: '',
				tempdata: null,
				outUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/EntryListOut'
			}
		},
		filters: {
			formatDate(val) {
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				return y + '-' + (m < 10 ? '0' + m : m)
			},
			formatFullDate(val) {
				if(val==null){
					return ''
				}
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				var d = now.getDate()
				return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
			}
		},
		methods: {
			// 调整每页显示数
			handleCurrentChange: function(val) {
				this.condition.firstSearch = false
				this.condition.currentPage = val
				this.$refs.btnSearch.Search()
			},
			// 分页操作
			handleSizeChange: function(val) {
				this.condition.firstSearch = false
				this.condition.pageSize = val
				this.condition.currentPage = 1
				this.$refs.btnSearch.Search()
			},
			JumpTo: function() {
				if (this.condition.entrydate == '' || this.condition.entrydate == null) {
					this.$message({
						message: '请先选择入科时间',
						type: 'warning'
					})
				} else {
					this.$router.push({
						name: 'UnEntryList',
						params: {
							entrydate: this.condition.entrydate
						}
					})
				}
			},
			beforeAvatarUpload: function(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
				}
				return isJPG
			},
			handleAvatarSuccess: function(res) {
				if (res.Code === 0) {
					this.$message({
						message: '上传成功',
						type: 'success'
					})
					this.$refs.upload.clearFiles()
					this.$refs.btnSearch.Search()
				} else {
					this.$message({
						message: res.Msg + '，' + res.Error,
						type: 'error'
					})
				}
			},
			See: function(row) {
				this.noticeimgVisible = true
				this.noticeimgurl = this.$utils.Url.zpgl + '/file/' + row.CPFile
			},
			GetOAStatus: function(row) {
				console.log(row)
				var args = {
					token: this.condition.token,
					cpid: row.CPID
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/GetOAStatus', args, function(data) {
					var OAStatus = data.Data
					if (OAStatus == 0) {
						that.SetTec(row)
					} else {
						that.$message({
							message: '前一个轮转科室尚未出科',
							type: 'warning'
						})
					}
				}, null, null, null)
			},
			SetTec: function(row) {
				console.log(row)
				this.dialogFormVisible = true
				this.tectableData = []
				this.form.selectCPID = row.CPID
				this.tecloading = true
				var args = {
					token: this.condition.token,
					section: row.CPSec
				}
				if(row.UserTypeName=="全科医师"){
					args.isqk='True'
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/CPTecList', args, function(data) {
					that.tectableData = data.Data
					that.tecloading = false
				}, null, null, null)
			},
			SaveTec: function(row) {
				var args = {
					token: this.condition.token,
					id: this.form.selectCPID,
					cptecid: row.TecID
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/SaveTec', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.$message({
								message: '设置成功',
								type: 'success'
							})
							console.log('设置成功')
							this.dialogFormVisible = false
							this.$refs.btnSearch.Search()
						} else {
							this.$message({
								message: res.data.Msg ,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '设置失败',
							type: 'error'
						})
					})
			},
			Notice: function() {
				this.noticeVisible = true
				
			},
			Print: function() {
				this.$router.push({
					name: 'NoticePrint',
					params: {
						truename: this.noticeform.truename,
						noticedate: this.noticeform.noticedate,
						realname: this.condition.truename,
						section: this.condition.section,
						cardno: this.condition.cardno,
						specialty: this.condition.specialty,
						entrydate: this.condition.entrydate,
						outdate: this.condition.outdate,
						secretarysec: this.condition.secretarysec
					}
				})
			},
			DownLoad: function() {
				this.fullscreenLoading = true
				this.noticeform.token = this.condition.token
				this.noticeform.username = this.condition.username
				this.noticeform.rolelevel = this.condition.rolelevel
				this.noticeform.realname = this.condition.truename
				this.noticeform.section = this.condition.section
				this.noticeform.cardno = this.condition.cardno
				this.noticeform.specialty = this.condition.specialty
				this.noticeform.entrydate = this.condition.entrydate
				this.noticeform.outdate = this.condition.outdate
				this.noticeform.secretarysec = this.condition.secretarysec

				// this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/OutNotice', this.noticeform)
				//   .then(res => {
				//     if (res.data.Code === 0) {
				//       var filename = res.data.Data
				//       var url = this.$utils.Url.zpgl + '/doc/' + filename
				//       window.open(url)
				//       this.noticeVisible = false
				//     } else {
				//       this.$message({
				//         message: '导出失败,' + res.data.Msg,
				//         type: 'error'
				//       })
				//     }
				//     this.fullscreenLoading = false
				//   })
				//   .catch(err => {
				//     this.fullscreenLoading = false
				//     console.log(err)
				//     this.$message({
				//       message: '导出失败',
				//       type: 'error'
				//     })
				//   })
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/NoticeDown', this.noticeform)
					.then(res => {
						if (res.data.Code === 0) {
							that.tempdata = JSON.parse(res.data.Data)
							JSZipUtils.getBinaryContent("/temp.docx", function(error, content) {
								if (error) {
									console.log(error.message)
									that.$message({
										message: '导出失败,' + error.message,
										type: 'error'
									})
								}

								let zip = new JSZip(content)
								let doc = new docxtemplater().loadZip(zip)
								console.log(that.tempdata)
								doc.setData({
									table: that.tempdata
								})
								try {
									// 用模板变量的值替换所有模板变量
									doc.render();
								} catch (error) {
									console.log(error.message)
									that.$message({
										message: '导出失败,' + error.message,
										type: 'error'
									})
								}
								// 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
								let out = doc.getZip().generate({
									type: "blob",
									mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
								});
								// 将目标文件对象保存为目标类型的文件，并命名
								saveAs(out, "入科报到通知单.docx");
								that.noticeVisible = false
							})
						} else {
							that.$message({
								message: '导出失败,' + res.data.Msg,
								type: 'error'
							})
						}
						that.fullscreenLoading = false
					})
					.catch(err => {
						that.fullscreenLoading = false
						console.log(err)
						that.$message({
							message: '导出失败',
							type: 'error'
						})
					})
			},
			UploadShow: function(row) {
				if (this.condition.rolelevel == '2') {//科秘书
					var entrydate
					var now = new Date(row.CPBeginDate)
					var date = new Date()
					var year = date.getFullYear()
					var month = date.getMonth() + 1
					var day = date.getDate()
					console.log(now)
					if (row.UserTypeName == "住院医师") {
						var zpdaylist = this.zpdays.split(',')
						var zpresults = false
						for (var i = 0; i < zpdaylist.length; i++) {
							var zplist = zpdaylist[i].split('-')
							entrydate = new Date(year + '/' + month + '/' + zplist[0])
							if (now < entrydate) {
								zpresults = false
							} else {
								if (day >= zplist[0] && day <= zplist[1]) {
									zpresults = true
								}
							}
						}
						return zpresults
					} else if (row.UserTypeName == "全科医师") {
						var qkdaylist = this.qkdays.split(',')
						var qkresult = false
						for (var j = 0; j < qkdaylist.length; j++) {
							var qklist = qkdaylist[j].split('-')
							entrydate = new Date(year + '/' + month + '/' + qklist[0])
							if (day >= qklist[0] && day <= qklist[1]) {
								if (now < entrydate) {
									qkresult = false
								} else {
									qkresult = true
								}
							}
						}
						return qkresult
					} else {
						return false
					}
				} 
				else {
					return true
				}
			},
			GetEntryDay: function() {
				var args = {
					token: this.condition.token
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/GetEntryDay', args)
					.then(res => {
						if (res.data.Code === 0) {
							this.zpdays = res.data.Data[0]["DictItemValue"]
							this.qkdays = res.data.Data[1]["DictItemValue"]

							this.$refs.btnSearch.Search()
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '设置失败',
							type: 'error'
						})
					})
			},
			LoadManageSec: function() {
				var args = {
					token: this.condition.token,
					username: this.condition.username,
					rolelevel: this.condition.rolelevel
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
					that.managesecOptions = data.Data
					that.GetEntryDay()
				}, null, null, null)
			},
			ManageSecChange: function() {
				this.condition.section = ''
				this.secOptions = []
				this.LoadCPSec()
			},
			LoadCPSec: function() {
				var args = {
					token: this.condition.token,
					username: this.condition.username,
					rolelevel: this.condition.rolelevel,
					mamagesec: this.condition.secretarysec
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
					that.secOptions = data.Data
				}, null, null, null)
			},
			Out: function() {
				this.$http.post(this.outUrl, this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
					})
			},
			OutOutSectionList: function() {
				if (this.condition.outdate == '') {
					this.$message({
						message: '出科时间不能为空',
						type: 'warning'
					})
					return
				}

				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/DownLoadOutSecionList', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
					})
			},
			InStuDownLoad: function() {
				if (this.instuform.cpdate == '') {
					this.$message({
						message: '轮转月份不能为空',
						type: 'warning'
					})
					return
				}

				var args = {
					token: this.condition.token,
					cpdate: this.instuform.cpdate
				}
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/DownLoadInStuList', args)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = that.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						} else {
							that.$message({
								message: '导出失败',
								type: 'error'
							})
						}
						that.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						that.$message({
							message: '导出失败',
							type: 'error'
						})
						that.fullscreenLoading = false
					})
			}
		},
		mounted: function() {
			this.condition.token = sessionStorage.getItem('token')
			this.noticeform.truename = sessionStorage.getItem('truename')
			this.condition.username = sessionStorage.getItem('username')
			this.condition.rolelevel = sessionStorage.getItem('rolelevel')
			this.condition.secid = sessionStorage.getItem('secid')
			var noticedate = new Date()
			var noticeyear = noticedate.getFullYear()
			var noticemonth = noticedate.getMonth() + 1
			var noticeday = noticedate.getDate()
			if (noticemonth >= 1 && noticemonth <= 9) {
				noticemonth = '0' + noticemonth
			}
			if (noticeday >= 1 && noticeday <= 9) {
				noticeday = '0' + noticeday
			}
			this.noticeform.noticedate = noticeyear + '-' + noticemonth + '-' + noticeday
			var date = new Date()
			var year = date.getFullYear()
			console.log(date.getMonth())
			var month = date.getMonth() + 1
			if (month > 12) {
				year = year + 1
				month = 1
			}
			if (month >= 1 && month <= 9) {
				month = '0' + month
			}
			this.condition.entrydate = year + '-' + month
			this.LoadManageSec()
		}
	}
</script>

<style scoped="scoped">
	.message-box {
		width: 600px;
	}

	.timeclass {
		width: 100%;
	}

::v-deep .el-table .cell {
		line-height: 25px;
	}

::v-deep .el-input {
		width: 220px;
	}
</style>
